(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[82407,92261,7797,5783,56012,75978,91058,99257,7019,46599,59654,55004,6050,12701,59679,68837,49105,54223,6169,13054,59544,54042,19341,97,33030],{

/***/ 49105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/components/Button/Button.module.scss
var Button_module = __webpack_require__(20195);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./UI/components/Button/utils/useButton.js







/* harmony default export */ function useButton(_param) {
    var dark = _param.dark, secondary = _param.secondary, href = _param.href, classes = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "dark",
        "secondary",
        "href",
        "className"
    ]);
    var Component = href ? function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
    } : function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread/* default */.Z)({
            type: "button"
        }, props));
    };
    var _obj;
    var className = classnames_default()((Button_module_default()).button, classes, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (Button_module_default()).secondary, secondary), (0,_define_property/* default */.Z)(_obj, (Button_module_default()).dark, dark), _obj));
    return (0,_object_spread/* default */.Z)({
        Component: Component,
        className: className,
        path: href
    }, rest);
};

;// CONCATENATED MODULE: ./UI/components/Button/index.jsx






var Button = function(props) {
    var _ref = useButton(props), Component = _ref.Component, children = _ref.children, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "Component",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
Button.propTypes = {
    disabled: (prop_types_default()).bool,
    secondary: (prop_types_default()).bool,
    dark: (prop_types_default()).bool,
    onClick: (prop_types_default()).func,
    href: (prop_types_default()).string
};
/* harmony default export */ var components_Button = (Button);


/***/ }),

/***/ 82407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var UI_components_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49105);
/* harmony import */ var UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18422);
/* harmony import */ var components_Common_FullScreenEstimation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92261);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73331);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);








var Typography = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 59654));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59654)
            ];
        }
    }
});
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var titles = param.titles, subtitle = param.subtitle, buttonTitle = param.buttonTitle, handleOnClick = param.handleOnClick, url = param.url;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(components_Common_FullScreenEstimation__WEBPACK_IMPORTED_MODULE_4__.FullscreenEstimationContext), handleOnCTAClick = ref.open;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content),
                children: [
                    titles === null || titles === void 0 ? void 0 : titles.map(function(titleText, index) {
                        return titleText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Typography, {
                            variant: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_TAGS.h3 */ .w1.h3,
                            size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_SIZE.headline24 */ .y3.headline24,
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().h3), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().title)),
                            children: titleText
                        }, "titleText/".concat(index));
                    }),
                    subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Typography, {
                        variant: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().p), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subtitle)),
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Button__WEBPACK_IMPORTED_MODULE_7__["default"], {
                onClick: !url && (handleOnClick || handleOnCTAClick),
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().button),
                href: url,
                "data-button": true,
                children: buttonTitle
            })
        ]
    });
};


/***/ }),

/***/ 59654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18422);






var Typography = function(props) {
    var _ref = (0,_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .useTypography */ .tj)(props), Tag = _ref.Tag, classes = _ref.classes, children = _ref.children, onClick = _ref.onClick, tabIndex = _ref.tabIndex, role = _ref.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "Tag",
        "classes",
        "children",
        "onClick",
        "tabIndex",
        "role"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest), {
        children: children
    }));
};
Typography.defaultProps = {
    variant: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
    size: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16
};
Typography.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    isBold: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    mobileSize: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 92261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FullscreenEstimationContext": function() { return /* binding */ FullscreenEstimationContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_Common_ModalWindow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79897);
/* harmony import */ var UI_components_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59654);
/* harmony import */ var UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18422);
/* harmony import */ var UI_components_LinkWrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56362);
/* harmony import */ var utils_constants_contacts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32522);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66723);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);










var FeedbackForm = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(53662), __webpack_require__.e(33714), __webpack_require__.e(84602), __webpack_require__.e(21148), __webpack_require__.e(43919), __webpack_require__.e(96419), __webpack_require__.e(49163), __webpack_require__.e(47569)]).then(__webpack_require__.bind(__webpack_require__, 49163));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49163)
            ];
        }
    },
    ssr: false
});
var FullScreenEstimation = function(param) {
    var isFullscreenEstimation = param.isFullscreenEstimation, closeFullscreenEstimation = param.closeFullscreenEstimation, extraDescription = param.extraDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Common_ModalWindow__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isModalWindow: isFullscreenEstimation,
        closeModalWindow: closeFullscreenEstimation,
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().fullscreenEstimation),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().estimationContainer),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    variant: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_SIZE.headline38 */ .y3.headline38,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                    isBold: true,
                    children: "Got a project in mind?"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    variant: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().subtitle),
                    children: [
                        "Fill in this form or",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_LinkWrapper__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            path: "mailto:".concat(utils_constants_contacts__WEBPACK_IMPORTED_MODULE_8__/* .EMAIL_LINK */ .Vr),
                            children: "send us an e-mail"
                        })
                    ]
                }),
                isFullscreenEstimation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeedbackForm, {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().feedbackForm),
                    isBudgetSlider: true,
                    formKey: "estimation",
                    extraDescription: extraDescription,
                    withoutAdditionalInfo: true
                })
            ]
        })
    });
};
FullScreenEstimation.propTypes = {
    isFullscreenEstimation: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().bool.isRequired),
    closeFullscreenEstimation: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().func.isRequired),
    extraDescription: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string)
};
var FullscreenEstimationContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isShown: false,
    open: function() {
        return null;
    }
});
/* harmony default export */ __webpack_exports__["default"] = (FullScreenEstimation);


/***/ }),

/***/ 79897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96076);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86324);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);









var Svg = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var ModalWindow = function(param) {
    var isModalWindow = param.isModalWindow, closeModalWindow = param.closeModalWindow, children = param.children, className = param.className;
    var modalRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var handleOnClick = function(param) {
        var target = param.target;
        if (modalRef && modalRef.current) {
            if (modalRef.current.isEqualNode(target)) closeModalWindow();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .setOverflowForBody */ .zd)(isModalWindow);
    }, [
        isModalWindow
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var handleOnKeyDown = function(param) {
            var key = param.key;
            if (key === "Escape") {
                closeModalWindow();
            }
        };
        document.addEventListener("keydown", handleOnKeyDown);
        return function() {
            return document.removeEventListener("keydown", handleOnKeyDown);
        };
    }, [
        closeModalWindow
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalWindowContainer), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().show), isModalWindow)),
        onClick: handleOnClick,
        ref: modalRef,
        role: "dialog",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalWindow), className),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Svg, {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().svg),
                    type: utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .SVG_IMAGES_TYPES.closeSvg */ .NL.closeSvg,
                    handleOnClick: closeModalWindow
                }),
                children
            ]
        })
    });
};
ModalWindow.defaultProps = {
    className: ""
};
ModalWindow.propTypes = {
    isModalWindow: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool.isRequired),
    closeModalWindow: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().func.isRequired),
    children: prop_types__WEBPACK_IMPORTED_MODULE_8___default().instanceOf(Object).isRequired,
    className: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalWindow);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 32522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ SOCIAL_MEDIA; },
/* harmony export */   "UE": function() { return /* binding */ PHONE_NUMBER; },
/* harmony export */   "Vr": function() { return /* binding */ EMAIL_LINK; },
/* harmony export */   "o4": function() { return /* binding */ ADDRESS; },
/* harmony export */   "zm": function() { return /* binding */ PLACEMENT_DATA; }
/* harmony export */ });

var EMAIL_LINK = "hi@yellow.systems";
var SOCIAL_MEDIA = {
    linkedin: {
        id: "linkedin",
        title: "LinkedIn",
        iconDark: "linkedinFilled",
        iconLight: "linkedinWhite",
        link: "https://www.linkedin.com/company/yellow-systems"
    },
    facebook: {
        id: "facebook",
        title: "Facebook",
        iconDark: "facebookDark",
        iconLight: "facebookWhite",
        link: "https://www.facebook.com/yellow.systems/"
    },
    twitter: {
        id: "twitter",
        title: "Twitter",
        iconDark: "twitterFilled",
        iconLight: "twitterWhite",
        link: "https://mobile.twitter.com/yellow_systems"
    },
    dribbble: {
        id: "dribbble",
        title: "Dribbble",
        iconDark: "dribbbleFilled",
        iconLight: "dribbbleWhite",
        link: "https://dribbble.com/yellow_systems"
    },
    behance: {
        id: "behance",
        title: "Behance",
        iconDark: "behanceFilled",
        iconLight: "behanceWhite",
        link: "https://www.behance.net/yellow_systems"
    },
    youtube: {
        id: "youtube",
        title: "YouTube",
        iconDark: "youtubeSocialFilled",
        iconLight: "youtubeWhite",
        link: "https://www.youtube.com/@yellowsystems9900"
    },
    instagram: {
        id: "instagram",
        title: "Instagram",
        iconDark: "instagramFilled",
        iconLight: "instagramWhite",
        link: "https://www.instagram.com/yellow.systems/"
    }
};
var PHONE_NUMBER = {
    us: "+1 (940) 601 6017"
};
var ADDRESS = {
    us: {
        addressCountry: "USA",
        addressLocality: "San Francisco",
        streetAddress: "44 Tehama St",
        postalCode: "94105"
    },
    ar: {
        addressCountry: "Argentina",
        addressLocality: "Buenos Aires",
        streetAddress: "Av. Corrientes 1312",
        postalCode: "C1043ABN"
    },
    pl: {
        addressCountry: "Poland",
        addressLocality: "Warszawa",
        streetAddress: "Grzybowska 62",
        postalCode: "00-855"
    },
    cy: {
        addressCountry: "Cyprus",
        addressLocality: "Larnaca",
        streetAddress: "Agias Faneromenis, 143, Flat 201",
        postalCode: "6031"
    }
};
var PLACEMENT_DATA = {
    USA: [
        "".concat(ADDRESS.us.streetAddress, " ").concat(ADDRESS.us.addressLocality, " ").concat(ADDRESS.us.postalCode), 
    ],
    Poland: [
        "".concat(ADDRESS.pl.addressLocality, " ").concat(ADDRESS.pl.postalCode),
        ADDRESS.pl.streetAddress, 
    ],
    Argentina: [
        "".concat(ADDRESS.ar.streetAddress, " ").concat(ADDRESS.ar.postalCode),
        ADDRESS.ar.addressLocality, 
    ]
};


/***/ }),

/***/ 20195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__uIelC","secondary":"Button_secondary__2AQtd","dark":"Button_dark__n_Cmy"};

/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ }),

/***/ 66723:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fullscreenEstimation":"styles_fullscreenEstimation__Rg_DE","estimationContainer":"styles_estimationContainer__gixM_","feedbackForm":"styles_feedbackForm__cR1Pq","title":"styles_title__07SXR","subtitle":"styles_subtitle__fjFtJ"};

/***/ }),

/***/ 86324:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalWindowContainer":"styles_modalWindowContainer__ob2Fw","modalWindow":"styles_modalWindow__y6P7Y","svg":"styles_svg__i9wAY","show":"styles_show__3kdTG"};

/***/ })

}]);